/*
 * Copyright (c) by INFODATA-GROUP. All rights reserved.
 * No part of this publication may be reproduced, distributed,
 * or transmitted in any form or by any means, including photocopying, recording,
 * or other electronic or mechanical methods, without the prior written permission of the publisher,
 * except in the case of brief quotations embodied in critical
 * reviews and certain other noncommercial uses permitted by copyright law.
 *  author : vhe
 *  date : 02/03/2021 07:39
 */

import { SimpleAction } from './simple-action';
import { HttpParams } from '@angular/common/http';

export class SearchAction extends SimpleAction<string> {
  public url: string;
  public params: HttpParams;
  public clearAfter = true;
  public searchOnUpdate = false;

  constructor(
    name: string,
    icon: string,
    placeholder: string,
    url: string,
    clearAfter?: boolean,
    searchOnUpdate?: boolean,
    align?: 'left' | 'right' | 'center',
  ) {
    super(name, icon, null, placeholder);
    this.data = url;
    this.category = 'search';
    this.clearAfter = clearAfter !== false;
    this.searchOnUpdate = !!searchOnUpdate;
    if (align) {
      this.align = align;
    }
  }

  override getActionType(): string {
    return 'search';
  }
}
